import { render, staticRenderFns } from "./ProfileBulkRoles.vue?vue&type=template&id=75f6b651&scoped=true"
import script from "./ProfileBulkRoles.vue?vue&type=script&lang=js"
export * from "./ProfileBulkRoles.vue?vue&type=script&lang=js"
import style0 from "./ProfileBulkRoles.vue?vue&type=style&index=0&id=75f6b651&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f6b651",
  null
  
)

export default component.exports